import { DvRowDragHandle } from './dv-row-drag-handle.js';
import { DvRowOps } from './dv-row-ops.js';
import { DvRowSelectCheckbox } from './dv-row-select-checkbox.js';

export { DvRowDragHandle } from './dv-row-drag-handle.js';
export { DvRowOps } from './dv-row-ops.js';
export { DvRowSelectCheckbox } from './dv-row-select-checkbox.js';
export { RowSelectionController } from './row-selection-controller.js';
export { getShiftKeyActive$ } from './shift-key-tracker.js';
export type { RowSelectionHost, SelectionModifiers } from './types.js';

/**
 * Idempotent `customElements.define` for view-agnostic row-selection
 * elements. Callers (table effect, gantt effect, …) invoke this from
 * their own `effect` bootstrap — the guard means it's safe to call
 * from every view without stepping on each other.
 */
export function rowSelectionEffects(): void {
  if (!customElements.get('dv-row-select-checkbox')) {
    customElements.define('dv-row-select-checkbox', DvRowSelectCheckbox);
  }
  if (!customElements.get('dv-row-drag-handle')) {
    customElements.define('dv-row-drag-handle', DvRowDragHandle);
  }
  if (!customElements.get('dv-row-ops')) {
    customElements.define('dv-row-ops', DvRowOps);
  }
}
